<script lang="ts">
	import { Img } from "flowbite-svelte";
	import { getContext } from "svelte";
	import type { BrandKit, Image } from "#gen/brands/v1/service_pb.js";
	import type { AssetRef } from "#gen/bundles/v1/bundle_pb.js";
	import Icon from "#lib/components/Icon.svelte";
	import P from "#lib/components/P.svelte";
	import { getAttemptedIconMatch } from "#lib/components/flow/editor/external/advancedDestinations/utils.js";
	import type { BundleNode } from "#lib/dag.js";
	import { getPrimaryIcon } from "#lib/theme.js";
	import type { Writable } from "svelte/store";

	interface Props {
		apps: BundleNode<AssetRef>[];
		readOnly?: boolean;
		onShow?: (node: BundleNode<AssetRef>) => void;
	}

	const brandKit: Writable<BrandKit | undefined> = getContext("brandKit");

	const { apps, readOnly = false, onShow }: Props = $props();
	const icon = $derived($brandKit ? getPrimaryIcon($brandKit!) : (undefined as Image | undefined));
</script>

<div class="flex h-full flex-col">
	<ul class="mt-4 flex flex-col gap-3 overflow-y-auto">
		{#each apps as app (app.key)}
			{@const dynamicIcon = getAttemptedIconMatch(app.ref, undefined) ?? { iconSet: "heroicons", icon: "link" }}
			<li>
				<button data-flow-button type="button" disabled={readOnly} onclick={() => onShow?.(app)} class="flex w-full items-center rounded-2xl border border-gray-300 bg-white p-2.5">
					{#if app.ref.iconUrl || icon?.url}
						<div class="flex h-8 w-8 flex-none items-center">
							<Img height="32" width="32" src={app.ref.iconUrl || icon?.url} class="flex-none rounded-lg" />
						</div>
					{:else}
						<div class="flex h-8 w-8 flex-none items-center">
							<Icon iconSet={dynamicIcon.iconSet} name={dynamicIcon.icon} class="h-5 w-5 rounded-lg" />
						</div>
					{/if}
					<P class="ml-2 grow text-sm font-semibold text-gray-900">
						{app.ref.shortName || app.ref.displayName}
					</P>
					<div><Icon name="chevron-right" class="h-5 w-5 text-gray-400" /></div>
				</button>
			</li>
		{/each}
	</ul>
</div>
